<template>
  <TransitionGroup
    name="slide-top-to-down"
    tag="div"
    class="Notifications PageContainer"
  >
    <Status
      v-for="notification of notificationsStore.notifications"
      :key="notification.id"
      class="Notifications-item"
      :status="notification.status"
      :persistent="notification.persistent"
      :actionPrimary="notification.actionPrimary"
      :actionSecondary="notification.actionSecondary"
      @close="handleClose(notification)"
      @click-primary="notification.onPrimaryClick"
      @click-secondary="notification.onSecondaryClick"
    >
      {{ notification.message }}
    </Status>
  </TransitionGroup>
</template>

<script setup lang="ts">
import type { NotificationItemStored } from '~/stores/notificationsStore.model';

const notificationsStore = useNotificationsStore();

function handleClose(notification: NotificationItemStored) {
  notification.onClose?.();
  notificationsStore.remove(notification.id);
}
</script>

<style lang="scss">
@use 'assets/scss/theme' as vars;
@use '@cvo/ui/styles/utils/responsive';

@layer cvo-base {
  .Notifications {
    position: fixed;
    inset-inline: 0;
    top: vars.$header-min-height-desktop + vars.$dimensions-d-5;
    z-index: vars.$z-index-notifications;
    display: flex;
    flex-direction: column;
    gap: vars.$dimensions-d-3;

    @include responsive.mobile {
      top: vars.$header-min-height-mobile + vars.$dimensions-d-5;
    }

    &.PageContainer {
      padding-block: 0;
    }


    &-item {
      box-shadow: vars.$shadow-md;
    }

    // Customization of slide transition to avoid layout shift when leaving
    .slide-top-to-down-leave-active {
      position: absolute;
      inset-inline: var(--page-padding-x);
    }
  }
}
</style>
